module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.careers.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.careers.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_2.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.careers.section_2.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.careers.section_2.button_link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.careers.section_2.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.careers.section_2.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.careers.section_2.image
    }
  })]) : _vm._e()])])], 1)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ddc0eb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/careers-tabs/working-at-ster-kinekor/working-at-ster-kinekor.vue
// module id = 946
// module chunks = 0